/**
 * @module sagas/Modal.js
 */
import { all, call, take } from 'redux-saga/effects';

import ViewActions from '../constants/ViewActions';
import * as ModalSagas from '../sagas/workers/Modal';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

function* watchOpenModalCoachmark() {
  while (LOOP) {
    const action = yield take(ViewActions.OPEN_MODAL_COACHMARK);
    yield call(ModalSagas.openModalCoachmark, action.payload);
  }
}

function* watchOpenModalReadOnlyMode() {
  while (LOOP) {
    yield take(ViewActions.OPEN_MODAL_READONLYMODE);
    yield call(ModalSagas.openReadOnlyModeMessage);
  }
}

/**
 * Root Modal Saga
 */
export default function* modalSaga() {
  yield all([spawn(watchOpenModalCoachmark), spawn(watchOpenModalReadOnlyMode)]);
}
